<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div #mapContainer [ngClass]="{ 'map-loading': !isMapConfigLoaded }" class="stretch-to-parent" style="overflow: hidden">
    <div *ngIf="isMapConfigLoaded" class="history-buttons-container">
        <div class="container-fluid map-actions-toolbar">
            <winde-map-actions-toolbar (triggerProjectSettingsPanel)="triggerProjectSettingsPanel($event)"></winde-map-actions-toolbar>
        </div>
        <div class="separator--row"></div>
        <div class="container-fluid">
            <winde-global-actions-toolbar></winde-global-actions-toolbar>
        </div>
    </div>

    <winde-steps-toolbar *ngIf="isMapConfigLoaded && historyService.logicalTopology"></winde-steps-toolbar>

    <winde-project-settings-panel
            (triggerProjectSettingsPanel)="triggerProjectSettingsPanel($event)"
            *ngIf="showProjectSettingsPanel"
    ></winde-project-settings-panel>

    <winde-unit-config></winde-unit-config>

    <winde-progress-window></winde-progress-window>
</div>

<winde-alerts-container></winde-alerts-container>
